import { useState } from "react"
import { homeCards } from "../../data/data"

export default function HomeCards() {
  const [cards] = useState(homeCards)

  return (
    <>
      <section className="max-width -mt-20">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:-mt-28">
          {cards.map(({ id, title, image, desc, button }) => (
            <article key={id} className="bg-white shadow rounded p-5">
              <div className="flex items-center mb-5">
                <img src={image} alt={title} />
                <h4 className="heading-2 text-2xl ml-3">{title}</h4>
              </div>

              <div>
                <p className="gray mb-5">{desc}</p>
                <button className="btn-light">{button}</button>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  )
}
